import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import {
  Button,
  Paper,
  Divider,
  Checkbox,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';
import SurveyDuplicate from './SurveyDuplicate';

import { useTrialHasStarted } from './useTrialHasStarted';
import { RootState } from '../../../redux/types';

const SurveySetting: React.FC<Props> = ({
  doSave,
  sections,
  optionalSections,
  setOptionalSections,
}: Props) => {
  const trialHasStarted = useTrialHasStarted();

  const onOptionalSectionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOptionalSections(event.target.checked);
  };

  return (
    <div className="w-100 pa2">
      <Paper elevation={3}>
        <div className="pv2 pl3">
          <FormattedMessage id="surveysettings.numberofsections.1" />
          {sections ? sections.length : 0}
          <FormattedMessage id="surveysettings.numberofsections.2" />
        </div>
        <Divider variant="middle" />
        <SurveyDuplicate disabled={trialHasStarted} />
        <Divider variant="middle" />
        <div className="pv2 pl3">
          <FormattedMessage id="surveysettings.setOptionalSurveys" />
          <Checkbox checked={optionalSections} onChange={onOptionalSectionChange} />
        </div>
        <Divider />
        <div className="pa2">
          <Button
            sx={{ my: 1 }}
            variant="contained"
            color="primary"
            onClick={() => doSave()}
          >
            <FormattedMessage id="save" />
          </Button>
        </div>
      </Paper>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  sections: state.surveyV2.sections,
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux & {
  doSave: () => void;
  optionalSections: boolean;
  setOptionalSections: React.Dispatch<React.SetStateAction<boolean>>
};
export default connector(SurveySetting);
